import SavedPropertiesContainer from './FavouritePropertiesContainer';

export default SavedPropertiesContainer;
